import BranchServiceTimePerService from "../../../components/branches/reports/daily/BranchServiceTimePerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchServiceTimePerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_service_time_per_service}
    title="Service Time Per Service"
    helmetTitle="Daily Branch Service Time Per Service"
    descriptionKey="ServiceTimePerServiceBranches"
    columnDefinitions={SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="completed"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) =>
      data.map((item, index) => (
        <BranchServiceTimePerService
          key={index}
          branchId={item.branchId}
          branchIndex={index + 1}
          data={item.servicesData}
          branchName={item.branchName}
          numServices={item.numServices}
          renderConfig={renderConfig}
          onRenderConfigChange={onRenderConfigChange}
        />
      ))
    }
  </DailyGeneratedReportPage>
);

export default DailyBranchServiceTimePerService;
